export default function MockSeguranca() {
  return (
    <div className="overflow-hidden rounded-3xl border border-background-200 bg-background-50">
      <img
        src="https://static.readdy.ai/image/22e92c18f0b031d861a5e53bf8e362fb/5e459d05fa3eec64da62c1a7539e65b7.png"
        alt="Painel de conformidade da plataforma get points com status de LGPD, BACEN 518 e auditoria ativa, trilha de auditoria e controles de segurança"
        title="Painel de conformidade e segurança da plataforma"
        className="block h-auto w-full"
      />
    </div>
  );
}